// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__hmqBw","fullWidth":"styles_fullWidth__N43K0"};